import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../config/siteConfig";
import { viewportOnce } from "../lib/motion";

const Panel = ({ id, tone, image, label, heading, cta, to, testid, delay }) => (
  <motion.div
    id={id}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={viewportOnce}
    transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1], delay }}
    className="relative overflow-hidden min-h-[440px] md:min-h-[560px] flex items-end group"
    data-testid={`${testid}-panel`}
  >
    <img src={image} alt={label} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
    <div className={`absolute inset-0 ${tone === "red" ? "bg-[#C62828]/85 mix-blend-multiply" : "bg-[#111111]/80"}`} />
    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
    <div className="relative z-10 p-9 md:p-12">
      <p className="overline text-white/70 text-xs mb-4">{label}</p>
      <h3 className="font-display text-3xl md:text-4xl text-white leading-tight max-w-md mb-8">{heading}</h3>
      <Link
        to={to}
        data-testid={`${testid}-cta`}
        className="inline-flex items-center gap-2 bg-white text-[#111111] font-accent uppercase tracking-widest text-xs px-7 py-4 rounded-sm hover:bg-[#C62828] hover:text-white transition-colors duration-400"
      >
        {cta} <ArrowRight size={15} />
      </Link>
    </div>
  </motion.div>
);

export const DualCTA = () => (
  <section id="employers" className="grid md:grid-cols-2" data-testid="dual-cta-section">
    <Panel
      id="employers-inner"
      tone="dark"
      image={IMAGES.employers}
      label="For Employers"
      heading="Looking for people who can make a difference?"
      cta="Talk to Our Recruitment Team"
      testid="employers"
      to="/contact"
      delay={0}
    />
    <Panel
      id="job-seekers"
      tone="red"
      image={IMAGES.jobseekers}
      label="For Job Seekers"
      heading="Your next opportunity could be closer than you think."
      cta="Explore Career Opportunities"
      testid="jobseekers"
      to="/job-seekers"
      delay={0.12}
    />
  </section>
);

export default DualCTA;
